import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {PreparationResourceTypeData} from "./preparation-resource-type.data";

@Injectable()
export class PreparationResourceTypeEntityModel extends EntityModel<PreparationResourceTypeData> {
    constructor(injector: Injector) {
        super(injector, PreparationResourceTypeData)
    }

}
